import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"add\"><title>add</title><g id=\"add__visibility\"><g id=\"add_Layer_8-2\" data-name=\"Layer 8\"><path d=\"M16.5,10H11V4.5a.5.5,0,0,0-1,0V10H4.5a.5.5,0,0,0,0,1H10v5.5a.5.5,0,0,0,1,0V11h5.5a.5.5,0,0,0,0-1Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/add.svg
// module id = HDdA
// module chunks = 4